export const initialCrrOptions = {
  lines: 15,
  list: false,
  background: true,
  bright: 80,
  font: 2,
  border: true,
};
